import { useSelectedDealer, useSelectedLocation } from "components";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { removeLocationChecklist } from "modules/ChecklistsDashboard/util";
import { ApiInstance } from "utils/Api";

import type { ChecklistID } from "models";

type DeleteChecklistPayload = {
  id: ChecklistID;
};

export const useDeleteChecklistMutation = () => {
  const { selectedDealer } = useSelectedDealer();
  const { selectedLocation } = useSelectedLocation();

  return useTypedMutation<DeleteChecklistPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/checklists/delete", payload, ENV.dealerBaseURL);
    },
    onSuccess: ({ id }) => {
      const defaultChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.defaultChecklists);
      const defaultChecklistIdx = defaultChecklists?.findIndex(dc => dc.id === id) ?? -1;
      if (defaultChecklists && defaultChecklistIdx !== -1)
        typedQueryClient.setQueryData(ChecklistsDashboardQueryKeys.defaultChecklists, defaultChecklists.toSpliced(defaultChecklistIdx, 1));

      const dealerChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.dealerChecklists(selectedDealer?.id));
      const dealerChecklistIdx = dealerChecklists?.findIndex(dc => dc.id === id) ?? -1;
      if (dealerChecklists && dealerChecklistIdx !== -1)
        typedQueryClient.setQueryData(ChecklistsDashboardQueryKeys.dealerChecklists(selectedDealer?.id), dealerChecklists.toSpliced(dealerChecklistIdx, 1));

      const locationChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.locationChecklists(selectedLocation?.id));
      const locationChecklistIdx = locationChecklists?.findIndex(lc => lc.id === id) ?? -1;
      if (!locationChecklists || locationChecklistIdx === -1) return;

      typedQueryClient.setQueryData(
        ChecklistsDashboardQueryKeys.locationChecklists(selectedLocation?.id),
        removeLocationChecklist(locationChecklists, locationChecklistIdx)
      );
    }
  });
};
